import { render, staticRenderFns } from "./planComparativeLoadin.vue?vue&type=template&id=b34d43ca"
import script from "./planComparativeLoadin.vue?vue&type=script&lang=js"
export * from "./planComparativeLoadin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports